import { useSearchAutocompleteMulti } from 'hooks/search'
import { graphql } from 'react-relay'
import { location_useCountriesAutocompleteQuery } from '__generated__/location_useCountriesAutocompleteQuery.graphql'
import { arrayFilterNonNullable } from 'services/array'

export function useCountriesAutocomplete() {
  return useSearchAutocompleteMulti<location_useCountriesAutocompleteQuery>(graphql`
    query location_useCountriesAutocompleteQuery ($search: String, $after: String) {
      countries(first: 20, filters: { name: $search }, after: $after) {
        edges {
          node {
            code
            name
          }
        }

        pageInfo {
          endCursor
        }
      }
    }
    `,
  search => ({ search }),
  data => data?.countries?.edges?.map(edge => (
    edge?.node?.name && edge?.node?.code ? {
      label: edge?.node?.name,
      value: edge?.node?.code?.toLowerCase(),
    } : null))?.filter(arrayFilterNonNullable) || [],
  {
    extractCursor: data => data?.countries?.pageInfo?.endCursor,
  })
}
